import { render, staticRenderFns } from "./BuspaketRating.vue?vue&type=template&id=c24cee22&"
import script from "./BuspaketRating.vue?vue&type=script&lang=js&"
export * from "./BuspaketRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports